/**
 * Parse a single line of JSONL format
 */
export function parseJsonLine(line: string): any | undefined {
  try {
    // Fix common LaTeX issues
    const fixed = line.replace(/ rac{/g, '\\\\frac{');

    // Try parsing as-is
    try {
      return JSON.parse(fixed);
    } catch {
      // Try with double backslashes
      return JSON.parse(fixed.replace(/\\/g, '\\\\'));
    }
  } catch {
    return undefined;
  }
}
